export var createSkillsApi = function (baseUrl, http) {
    var api = {
        getSkills: function () { return http.get("".concat(baseUrl, "/skills")); },
        getSpecificSkill: function (dto) { return http.get("".concat(baseUrl, "/skills/").concat(dto.id)); },
        deleteSkill: function (dto) { return http.delete("".concat(baseUrl, "/skills/").concat(dto.id)); },
        addSkill: function (dto) { return http.post("".concat(baseUrl, "/skills/"), dto); },
        renameSkill: function (dto) { return http.put("".concat(baseUrl, "/skills/").concat(dto.id), dto); },
        updateAgentSkillsAssignment: function (dto) { return http.put("".concat(baseUrl, "/agents/").concat(dto.agentId, "/skillIds"), { skillIds: dto.assignedSkills }); },
        deleteAgentSkills: function (dto) { return http.delete("".concat(baseUrl, "/agents/").concat(dto.id, "/skillIds")); }
    };
    return api;
};
//# sourceMappingURL=index.js.map